<template>
<div>
    <router-view></router-view>
</div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    created() {
        this.getCerfitycateList();
    },
    methods: {
        getCerfitycateList() {
            this.$http.post("/api/XOrg/AssociationIndex/getCertificateList").then(res => {
                if (res.code > 0) {
                    this.certifycateList = res.list;
                    if (res.list.length > 0) {
                        const [{
                            id
                        }] = this.certifycateList;
                        this.$router.push({
                            name: 'introMain',
                            params: {
                                certifyId: id
                            }
                        });
                    }
                }
            });
        },
    }
}
</script>

<style lang="scss">

</style>
